import axios from "axios";
import {
  config,
  GetPatientInfo,
  GetMedication,
  GetDiagnosis,
  GetInternments,
  GetWounds,
  StructureCardsPatient,
  GetEpisodes,
  urlReportType
} from "../../../utils/constants";
import { isDefined } from "../../../utils/utils";

export function getPatientInfo(patientID) {
  var language = localStorage.getItem("i18nextLng") || "pt";
  if (language.length > 2) {
    language = language.substr(0, 2).toUpperCase();
  }
  else {
    language = language.toUpperCase();
  }

  var url = `${config.url.API_URL}${GetPatientInfo}?id=${patientID}&language=${language}`;

  return dispatch => {
    axios
      .get(url)
      .then(resp => {
        dispatch([
          {
            type: "PATIENT_INFO",
            payload: resp,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "PATIENT_INFO",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
}

export function getMedication(patientID) {
  var url = `${config.url.API_URL}${GetMedication}?id=${patientID}`;

  return dispatch => {
    axios
      .get(url)
      .then(resp => {
        dispatch([
          {
            type: "PATIENT_MEDICATION_INFO",
            payload: resp,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "PATIENT_MEDICATION_INFO",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
}

export function getInternments(patientID) {
  var url = `${config.url.API_URL}${GetInternments}?id=${patientID}`;

  return dispatch => {
    axios
      .get(url)
      .then(resp => {
        dispatch([
          {
            type: "PATIENT_INTERNMENTS_INFO",
            payload: resp,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "PATIENT_INTERNMENTS_INFO",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
}

export function getDiagnosis(patientID) {
  var url = `${config.url.API_URL}${GetDiagnosis}?id=${patientID}`;

  return dispatch => {
    axios
      .get(url)
      .then(resp => {
        dispatch([
          {
            type: "PATIENT_DIAGNOSIS_INFO",
            payload: resp,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "PATIENT_DIAGNOSIS_INFO",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
}

export function getWoundsOpened(patientID, episodeID) {
  var language = localStorage.getItem("i18nextLng") || "pt";
  if (language.length > 2) {
    language = language.substr(0, 2).toUpperCase();
  }
  else {
    language = language.toUpperCase();
  }

  let filterEpisode = "";
  if (episodeID > 0) {
    filterEpisode = `&episodeId=${episodeID}`
  }

  var url = `${config.url.API_URL}${GetWounds}?patientId=${patientID}&state=Opened&language=${language}` + filterEpisode;

  return dispatch => {
    axios
      .get(url)
      .then(resp => {
        dispatch([
          {
            type: "PATIENT_WOUNDS_INFO",
            payload: resp,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "PATIENT_WOUNDS_INFO",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
}

export function getStructureCards(patientID) {
  var language = localStorage.getItem("i18nextLng") || "pt";
  if (language.length > 2) {
    language = language.substr(0, 2).toUpperCase();
  }
  else {
    language = language.toUpperCase();
  }
  var url = `${config.url.API_URL}${StructureCardsPatient}?patientId=${patientID}&language=${language}`;

  return dispatch => {
    axios
      .get(url)
      .then(resp => {
        dispatch([
          {
            type: "PATIENT_STRUCTURECARDS",
            payload: resp,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "PATIENT_STRUCTURECARDS",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
}

//promise.all permite fazer vários pedido e retorna o resultado de cada um deles
/* export function getPatientInfoAndStrutureCards(
  patientID,
  includeWoundsClosed,
  includeWoundsOpen,
  idEpisode
) {

  var language = localStorage.getItem("i18nextLng") || "pt";
  if (language.length > 2) {
    language = language.substr(0, 2).toUpperCase();
  }
  else {
    language = language.toUpperCase();
  }
  var urlPatient = `${config.url.API_URL}${GetPatientInfo}?id=${patientID}&language=${language}`;

  var urlCards = `${config.url.API_URL}${StructureCardsPatient}?patientId=${patientID}&language=${language}`;

  var urlWounds;
  var filterEpisode = "";
  if (idEpisode > 0) {
    filterEpisode = `&episodeId=${idEpisode}`
  }

  if (includeWoundsClosed && includeWoundsOpen) {
    urlWounds = `${config.url.API_URL}${GetWounds}?patientId=${patientID}&state=All&language=${language}` + filterEpisode;
  } else if (includeWoundsClosed && !includeWoundsOpen) {
    urlWounds = `${config.url.API_URL}${GetWounds}?patientId=${patientID}&state=Closed&language=${language}` + filterEpisode;
  } else {
    urlWounds = `${config.url.API_URL}${GetWounds}?patientId=${patientID}&state=Opened&language=${language}` + filterEpisode;
  }

  var urlEpisodes = `${config.url.API_URL}${GetEpisodes}?PatientId=${patientID}`;

  return dispatch => {
    Promise.all([
      axios.get(urlPatient),
      axios.get(urlCards),
      axios.get(urlWounds),
      axios.get(urlEpisodes)
    ])
      .then(([respPatient, respCards, respWounds, respEpisodes]) => {
        dispatch([
          {
            type: "PATIENT_INFO_AND_CARDS",
            payload: respPatient,
            cards: respCards,
            wounds: respWounds,
            episodes: respEpisodes,
            idEpisode: idEpisode,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "PATIENT_INFO_AND_CARDS",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
} */

export function getPatientInfoAndStrutureCards(
  patientID,
  includeWoundsClosed,
  includeWoundsOpen,
  idEpisode
) {

  var language = localStorage.getItem("i18nextLng") || "pt";
  if (language.length > 2) {
    language = language.substr(0, 2).toUpperCase();
  }
  else {
    language = language.toUpperCase();
  }
  var urlPatient = `${config.url.API_URL}${GetPatientInfo}?id=${patientID}&language=${language}`;

  var urlCards = `${config.url.API_URL}${StructureCardsPatient}?patientId=${patientID}&language=${language}`;

  var urlWounds;
  var filterEpisode = "";

  var urlEpisodes = `${config.url.API_URL}${GetEpisodes}?PatientId=${patientID}`;

  return dispatch => {
    axios.get(urlEpisodes)
      .then(function (response) {
        if (!isDefined(idEpisode) || (isDefined(idEpisode) && idEpisode < 0)) {
          if (response.status === 200) {
            if (response.data.result.length > 0) {
              if (isDefined(response.data.result[0])) {
                idEpisode = response.data.result[0].id
              } else {
                idEpisode = 0
              }
            } else {
              idEpisode = 0
            }
          }
        }
        /*       if (!isDefined(idEpisode) || (isDefined(idEpisode) && idEpisode < 0)){
                
                if (response.status === 200){
                  if (response.result.length > 0)
                  {
                    idEpisode = response.result[0].id
                  }
                }
              } */

        if (idEpisode > 0) {
          filterEpisode = `&episodeId=${idEpisode}`
        }

        if (includeWoundsClosed && includeWoundsOpen) {
          urlWounds = `${config.url.API_URL}${GetWounds}?patientId=${patientID}&state=All&language=${language}` + filterEpisode;
        } else if (includeWoundsClosed && !includeWoundsOpen) {
          urlWounds = `${config.url.API_URL}${GetWounds}?patientId=${patientID}&state=Closed&language=${language}` + filterEpisode;
        } else {
          urlWounds = `${config.url.API_URL}${GetWounds}?patientId=${patientID}&state=Opened&language=${language}` + filterEpisode;
        }

        var urlWoundsOpened = `${config.url.API_URL}${GetWounds}?patientId=${patientID}&state=Opened&language=${language}` + filterEpisode;

        Promise.all([
          axios.get(urlPatient),
          axios.get(urlCards),
          axios.get(urlWounds),
          axios.get(urlEpisodes),
          axios.get(urlWoundsOpened)
        ])
          .then(([respPatient, respCards, respWounds, respEpisodes, respWoundsOpened]) => {
            dispatch([
              {
                type: "PATIENT_INFO_AND_CARDS",
                payload: respPatient,
                cards: respCards,
                wounds: respWounds,
                episodes: respEpisodes,
                idEpisode: idEpisode,
                error: false,
                woundsOpened: respWoundsOpened
              }
            ]);
          })
          .catch(e => {
            dispatch([
              {
                type: "PATIENT_INFO_AND_CARDS",
                payload: e.response,
                error: true
              }
            ]);
          });
      })
      .catch(err => {
        dispatch([
          {
            type: "PATIENT_INFO_AND_CARDS",
            payload: err.response,
            error: true
          }
        ]);
      });
  }
}

/* export function getPatientEpisodes(patientID) {
  var url = `${config.url.API_URL}${GetEpisodes}?PatientId=${patientID}`;

  return dispatch => {
    axios
      .get(url)
      .then(resp => {
        dispatch([
          {
            type: "PATIENT_EPISODES",
            payload: resp,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "PATIENT_EPISODES",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
}  */

export function getReportsType(reportType) {
  var url = `${config.url.API_URL}${urlReportType}?ReportType=${reportType}`;

  return dispatch => {
    axios
      .get(url)
      .then(resp => {
        dispatch([
          {
            type: "REPORT_TYPE",
            payload: resp,
            error: false
          }
        ]);
      })
      .catch(e => {
        dispatch([
          {
            type: "REPORT_TYPE",
            payload: e.response,
            error: true
          }
        ]);
      });
  };
}
